import {
  APIGetRequest,
  GiftCardAddonOnlineResponse,
} from '@ancon/wildcat-types'

import Request from '../../client/Request'
import { APIType } from '../../types'
import endpoints from '../endpoints'

type GiftCardAddOnAPI = {
  get: {
    giftCardAddon: APIGetRequest<
      GiftCardAddonOnlineResponse,
      { urlSlug: string }
    >
  }
}

const giftCardAddon: GiftCardAddOnAPI = {
  get: {
    giftCardAddon: new Request(
      endpoints.integration.outlets.giftCardAddon.online.list,
      {
        apiType: APIType.Integration,
      },
    ).get,
  },
}

export default giftCardAddon
